import { appSchema } from '@shared/schema/appSchema.js';
import React from 'react';
import DataTypeIcon from '../components/DataTypeIcon';

const attributeDataTypeOptions = (() => {
  const array = [{ label: 'Array', value: 'array', icon: <DataTypeIcon label={'Array'} /> }];
  const object = [{ label: 'Object', value: 'object', icon: <DataTypeIcon label={'Object'} /> }];
  return appSchema.general.dataTypes
    .map((n) => ({
      label: n.label,
      value: n.value,
      icon: <DataTypeIcon label={n.label} />
    }))
    .concat(array, object);
})();

export default attributeDataTypeOptions;
